export default __webpack_public_path__ + "static/media/eye-icon-closed.939715af.svg";